export * from './input-cnpj.component';
